import { ObjectValues } from './types/types';

export const KML_FEATURE_TYPE = {
  PULLIN: 'pullin',
  PARKING_POINT: 'parking_point',
  STARTING_POINT: 'starting_point',
  END_POINT: 'end_point',
  CORE_POINT: 'core point',
  DUMP_EVENT: 'dump event',
  CENTROID: 'centroid',
  FIELD: 'field',
  COLLECTED_FIELD: 'collected field',
  UNSAFE: 'unsafe',
  SLOW: 'slow',
  GENERIC_ZONE: 'generic_zone',
  SAMPLE_ZONE: 'sample_zone',
  VISUAL_ZONE: 'visual_zone',
  POLY: 'poly',
  LASSO_ZONE: 'lasso_zone',
  PATH: 'path',
  REORDER_LINE: 'reorder line',
  CORE_LINE: 'core line',
  ERASER: 'eraser',
  CUTTER: 'cutter',
} as const;

export type KmlFeatureType = ObjectValues<typeof KML_FEATURE_TYPE>;
